module.exports = __webpack_public_path__ + "static/blueair-f50da0f3ca2ab32d31cc893032811a60.png";